export const LARGE = "large";
export const MEDIUM = "medium";
export const SMALL = "small";
